import { captureError } from 'conversations/utils/logRocket'

export const transformResponseIdToString = (idKey: string) => [
  (data: string) => replaceBigIdWithString(data, idKey),
]

function replaceBigIdWithString<T>(data: string, idKey: string): T {
  const regex = new RegExp(`"${idKey}":((\\d|\\.)+)`, 'g')
  try {
    return JSON.parse(data.replace(regex, `"${idKey}":"$1"`))
  } catch (ex) {
    captureError(ex, 'Replace big ID with string failed')
    return JSON.parse(data)
  }
}
